import styled from "styled-components"
import { Modal } from "react-bootstrap"

export const Header = styled(Modal.Header)`
  display: "flex";
  justify-content: "center";
  align-items: "center";
  width: 100%;
  background-image: linear-gradient(to right, #f94a5b, #808af1 100%);
  color: #fff;
  background-size: 100%;
  background-repeat: repeat-y;
  border-radius: 4px;
  border: none;
  outline: 0;
  &.mobile {
    margin: 0;
    width: 49%;
  }
`

export const SolidButton = styled.button`
  width: 100%;
  padding: 10px 0;
  margin-top: 20px;
  display: flex;
  background-image: linear-gradient(to right, #f94a5b, #808af1 100%);
  font-family: "PT Sans", sans-serif;
  color: #fff;
  background-size: 100%;
  background-repeat: repeat-y;
  border-radius: 4px;
  border: none;
  outline: 0;
  transition: all 0.3s ease-out;
  justify-content: center;
  &:hover {
    background-size: 370%;
    background-position: unset;
  }
  &.mobile {
    margin: 0;
    width: 49%;
  }
`

export const Exclude = styled.button`
  display: inline-block;
  width: 22px;
  height: 22px;
  line-height: 15px;
  border-radius: 50%;
  color: #c19acb;
  border: 2px solid #c19acb;
  vertical-align: middle;
  text-align: center;
  font-size: 12px;
  padding: 1px 0px 0 0;
`

export const Title = styled(Modal.Title)`
  text-align: center;
`

export const Footer = styled(Modal.Footer)`
  width: 100%;
  display: flex;
  flex: 1;
`

export const IconDelete = styled.a`
  display: block;
  width: 20px;
  height: 20px;
  margin: 0 auto;
  background-image: url("/images/excluir.png");
  background-size: contain;
`
export const Confirm = styled.button`
  width: 30%;
  padding: 10px 0;
  display: flex;
  background-image: linear-gradient(to right, #f94a5b, #808af1 100%);
  font-family: "PT Sans", sans-serif;
  color: #fff;
  background-size: 100%;
  background-repeat: repeat-y;
  border-radius: 4px;
  border: none;
  outline: 0;
  transition: all 0.3s ease-out;
  justify-content: center;
  &:hover {
    background-size: 370%;
    background-position: unset;
  }
  &.mobile {
    margin: 0;
    width: 49%;
  }
  &.resume {
    width: 100%;
  }
`
export const DenyText = styled.span``

export const BodyText = styled.p`
  font-size: 18px;
  margin-top: 8px;
`

export const Deny = styled.button`
  width: 30%;
  margin: 0;
  padding: 10px 0;
  vertical-align: middle;
  box-sizing: border-box;
  background-clip: padding-box, border-box;
  background-origin: padding-box, border-box;
  border: 1px solid transparent;
  background-image: linear-gradient(#ffffff, #ffffff), linear-gradient(80deg, #f94a5b 0%, #808af1);
  transition-duration: 0.2s;
  transition-property: background-image;
  transition: 0.2s all linear;
  border-radius: 4px;
  > ${DenyText} {
    background: linear-gradient(80deg, #f94a5b 0%, #808af1);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    transition: 0.2s all linear;
    font-family: "PT Sans", sans-serif;
  }
  &.resume {
    width: 100%;
    border: 0;
    padding: 20px 0;
  }
  &.mobile {
    width: 49%;
    padding: 0;
  }
`

export const CancelText = styled.div`
  background: linear-gradient(80deg, #f94a5b 0%, #808af1);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  transition: 0.2s all linear;
  font-size: 16px;
  font-family: "PT Sans", sans-serif;
`
